export default __webpack_public_path__ + "static/emergency-120fb02322b62c2c736f1b116f65f29b.png";